// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetMainProductsByIdParam,
    BaseResponseMainProductFoundResponse,
    PutMainProductsByIdParam,
    PutMainProductsByIdBody,
    BaseResponseVoid,
    DeleteMainProductsByIdParam,
} from '../../types';

/**
 * findById
 *
 * @export
 * @tags main-product-controller
 * @link [GET] /mainProducts/{id}
 * @param id
 */
export function getMainProductsById(
    options: ApiOptions<GetMainProductsByIdParam, never> & { segments: GetMainProductsByIdParam }
): Promise<BaseResponseMainProductFoundResponse> {
    return request<never, GetMainProductsByIdParam, never>('/mainProducts/{id}', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getMainProductsById',
    });
}

/**
 * update
 *
 * @export
 * @tags main-product-controller
 * @link [PUT] /mainProducts/{id}
 * @param id
 */
export function putMainProductsById(
    data: PutMainProductsByIdBody,
    options: ApiOptions<PutMainProductsByIdParam, never> & { segments: PutMainProductsByIdParam }
): Promise<BaseResponseVoid> {
    return request<PutMainProductsByIdBody, PutMainProductsByIdParam, never>('/mainProducts/{id}', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putMainProductsById',
    });
}

/**
 * deleteById
 *
 * @export
 * @tags main-product-controller
 * @link [DELETE] /mainProducts/{id}
 * @param id
 */
export function deleteMainProductsById(
    options: ApiOptions<DeleteMainProductsByIdParam, never> & {
        segments: DeleteMainProductsByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeleteMainProductsByIdParam, never>('/mainProducts/{id}', {
        ...options,
        method: 'delete',
        __$requestCalleeName: 'deleteMainProductsById',
    });
}

export const meta = [
    { tags: ['main-product-controller'], path: '/mainProducts/{id}', method: 'get' },
    { tags: ['main-product-controller'], path: '/mainProducts/{id}', method: 'put' },
    { tags: ['main-product-controller'], path: '/mainProducts/{id}', method: 'delete' },
];
